import React, { useState } from 'react';
import { IoEyeOutline, IoEyeOffOutline } from 'react-icons/io5';

interface InputProps {
  type?: 'text' | 'password' | 'email';
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: boolean;
  errorMessage?: string;
  required?: boolean;
  autoComplete?: 'on' | 'off';
  className?: string;
  disabled?: boolean;
  name?: string;
  id?: string;
  icon?: React.ReactNode;
}

export const Input: React.FC<InputProps> = ({
  type = 'text',
  label,
  value,
  onChange,
  placeholder,
  error = false,
  errorMessage,
  required = false,
  autoComplete = 'off',
  className = '',
  disabled = false,
  name,
  id,
  icon,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const inputType = type === 'password' && showPassword ? 'text' : type;

  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={id}
          className="mb-2 block text-start text-sm font-medium text-neutralText opacity-90 dark:text-neutralText-dark"
        >
          {label}
        </label>
      )}
      <div className="relative">
        {icon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-neutralText opacity-40">
            {icon}
          </div>
        )}
        <input
          type={inputType}
          id={id}
          name={name}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className={`text-md w-full select-none rounded-md border border-neutralText border-opacity-20 bg-[transparent] font-light text-neutralText dark:border-neutralText-dark dark:border-opacity-20 dark:text-neutralText-dark ${
            error ? '!border-errorText dark:!border-errorText-dark' : ''
          } ${disabled ? 'cursor-not-allowed opacity-50' : ''} ${className}`}
          required={required}
          autoComplete={autoComplete}
          disabled={disabled}
        />
        {type === 'password' && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-neutralText opacity-60 hover:opacity-100 dark:text-neutralText-dark"
          >
            {showPassword ? (
              <IoEyeOffOutline className="text-xl" />
            ) : (
              <IoEyeOutline className="text-xl" />
            )}
          </button>
        )}
      </div>
      {error && errorMessage && (
        <div className="mt-1 text-sm text-errorText dark:text-errorText-dark">
          {errorMessage}
        </div>
      )}
    </div>
  );
};
